import { render, staticRenderFns } from "./RoundOverallBottom.vue?vue&type=template&id=8fb06f72&scoped=true&"
import script from "./RoundOverallBottom.vue?vue&type=script&lang=js&"
export * from "./RoundOverallBottom.vue?vue&type=script&lang=js&"
import style0 from "./RoundOverallBottom.vue?vue&type=style&index=0&id=8fb06f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb06f72",
  null
  
)

export default component.exports